// extracted by css-extract-rspack-plugin
export default {"AntButton":"src-components-button-Styles-module__AntButton-FthcOJ","antButton":"src-components-button-Styles-module__AntButton-FthcOJ","AntButtonDanger":"src-components-button-Styles-module__AntButtonDanger-D9gJ58","antButtonDanger":"src-components-button-Styles-module__AntButtonDanger-D9gJ58","AntButtonDefault":"src-components-button-Styles-module__AntButtonDefault-THf8Eo","antButtonDefault":"src-components-button-Styles-module__AntButtonDefault-THf8Eo"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"AntButton\":\"src-components-button-Styles-module__AntButton-FthcOJ\",\"antButton\":\"src-components-button-Styles-module__AntButton-FthcOJ\",\"AntButtonDanger\":\"src-components-button-Styles-module__AntButtonDanger-D9gJ58\",\"antButtonDanger\":\"src-components-button-Styles-module__AntButtonDanger-D9gJ58\",\"AntButtonDefault\":\"src-components-button-Styles-module__AntButtonDefault-THf8Eo\",\"antButtonDefault\":\"src-components-button-Styles-module__AntButtonDefault-THf8Eo\"}";
        // 1773737313977
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.7.6_@swc+helpers@0.5.19/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  